import { css } from '@emotion/core';
import { media, variables, tokens, shadow } from '@domain-group/fe-brary';
import { typography, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors,
  shadows = tokens.shadows;
export var container = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;min-width:300px;padding:24px 16px;border-radius:3px;background-color:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";font-family:", font.bodyFontFamily, ";box-shadow:", shadow(shadows.elevation4), ";", media('>=tablet'), "{width:324px;margin:0;}");
export var avatar = {
  name: "1bgygk5",
  styles: "display:block;width:180px;height:180px;margin-bottom:16px;"
};
export var logo = /*#__PURE__*/css("height:30px;text-align:center;overflow:hidden;", media('>=tablet'), "{display:none;}");
export var logoImg = {
  name: "10klw3m",
  styles: "height:100%;"
};
export var name = /*#__PURE__*/css(truncateLines(2), " ", typography.headingL, " max-width:100%;color:", colors.neutral.heavy.default, ";text-align:center;");
export var details = /*#__PURE__*/css("height:auto;margin:15px 10px 0;text-align:center;", media('>=tablet'), "{height:auto;text-align:left;}");
export var jobTitle = /*#__PURE__*/css(truncateLines(2), " ", typography.bodyLong, " color:", colors.neutral.medium.default, ";text-align:center;");
export var address = /*#__PURE__*/css("display:inline-block;max-width:100%;height:34px;font-size:", font.smallFontSize, ";color:", colors.neutral.medium.default, ";text-align:left;white-space:nowrap;position:relative;line-height:1.13;", media('>=tablet'), "{margin-bottom:5px;position:relative;width:270px;margin-left:31px;}");

// This is used to move the buttons to the bottom of the card */
export var buttonGroupContainer = {
  name: "1enhumf",
  styles: "flex-grow:1;display:flex;flex-direction:column;justify-content:end;width:100%;margin-top:16px;padding:0 8px;"
};
export var buttonGroup = {
  name: "1hvnjby",
  styles: "display:flex;flex-direction:row;justify-content:space-between;white-space:nowrap;width:100%;max-width:100%;overflow:hidden;gap:12px;"
};
export var emailButton = {
  name: "1rr4qq7",
  styles: "flex:1;"
};
export var socials = {
  name: "13vab6w",
  styles: "display:flex;flex-direction:row;margin-top:16px;"
};
export var socialIcon = /*#__PURE__*/css("display:flex;align-items:center;justify-content:center;height:32px;width:32px;border-radius:16px;color:", colors.neutral.heavy.default, ";background-color:", colors.neutral.subdued.default, ";margin:0 4px;");
export var addressIcon = {
  name: "11k85g4",
  styles: "position:relative;top:-5px;"
};
export var pills = {
  name: "1cd8nnu",
  styles: "margin-bottom:14px;"
};